import React, { useState, useEffect } from "react";
import {BASE_URL } from "../../../Config/AppConstant";
import {
  Col,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  Card,
  CardHeader,
  CardBody,
  Form,
  FormGroup,
  Label,
  Input,
  ModalFooter,
} from "reactstrap";
import { Btn } from "../../../AbstractElements";
import { useDispatch } from "react-redux";
import { editServiceCategory,fetchServiceCategories } from "../../../Redux/stateSlice/serviceCategoryReducer";

const EditModal = (props) => {
  const dispatch = useDispatch();

  const [formData, setFormData] = useState({
    categoryName: "",
    file: null,
  });

  console.log(props.category)

  useEffect(() => {
    if (props.category) {
      setFormData({
        categoryName: props.category.name || "",
        file: null,
      });
    }
  }, [props.category]);

  const handleInputChange = (e) => {
    const { name, value, files } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: files ? files[0] : value,
    }));
  };

  const handleEditCategory = async(dataNew) => {
    if (!formData.categoryName) {
      alert("Please fill all required fields.");
      return;
    }
  
    const data = new FormData();
    data.append("name", formData.categoryName);
    if (formData.file) {
      data.append("image", formData.file); // Only include the file if provided
    }
    console.log(dataNew._id)
  
    console.log("edit-data", {
      id: dataNew._id,
      payload: formData.file ? "Updating name and image" : "Updating only name",
    });
  
   await dispatch(editServiceCategory(dataNew._id, data));
    props.EditModaltoggle();
  await  dispatch(fetchServiceCategories(1, 10))
  };
  

  return (
    <Modal
      isOpen={props.editModal}
      toggle={props.EditModaltoggle}
      size="md"
      centered
    >
      <ModalHeader
        style={{ padding: "15px 0px 0px 20px!important" }}
        toggle={props.EditModaltoggle}
      >
        Edit Category
      </ModalHeader>
      <hr />
      <ModalBody>
        <Form className="theme-form">
          <FormGroup>
            <Label className="col-form-label pt-0">Category Name</Label>
            <Input
              className="form-control"
              type="text"
              name="categoryName"
              placeholder="Category Name"
              value={formData.categoryName}
              onChange={handleInputChange}
            />
          </FormGroup>
          <FormGroup>
            <img src={`${BASE_URL}/uploads/${props?.category?.categoryIcon}`} width={'60'} height={'60'} />
          </FormGroup>
          <FormGroup>
            <Label className="col-sm-3 col-form-label">Upload File</Label>
            <Col sm="9">
              <Input
                className="form-control"
                type="file"
                name="file"
                onChange={handleInputChange}
              />
            </Col>
          </FormGroup>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Btn attrBtn={{ color: "secondary", onClick: props.EditModaltoggle }}>
          Close
        </Btn>
        <Btn attrBtn={{ color: "primary", onClick:()=> handleEditCategory(props.category) }}>
          Save
        </Btn>
      </ModalFooter>
    </Modal>
  );
};

export default EditModal;
